import { useTranslation } from "react-i18next";
import SectionHeading from "../components/SectionHeading";
import SectionSubheading from "../components/SectionSubheading";
import AboutUsDescription from "../components/AboutUsDescription";
import DirectionsFeatureBlock from "../components/DirectionsFeatureBlock";
import { useInternationalizedItems } from "../custom-hooks/useInternationalizedItems";
import { HeadingVariant } from "../types/constants";

type ParagraphText =
    | string
    | {
          before: string;
          highlight: string;
          after: string;
      };

export default function DirectionsSection() {
    const { t } = useTranslation();

    const paragraphs = useInternationalizedItems<ParagraphText[]>({
        key: "home.paragraphs.directionsDescription",
    });

    return (
        <section>
            <div className="flex flex-col gap-[32px] lg:gap-[20px] items-start">
                <div className="flex flex-col w-full lg:w-[630px]">
                    <div className="mb-[24px]">
                        <SectionHeading text={t("home.headings.directions")} variant={HeadingVariant.DARK} />
                    </div>
                    <div className="mb-[12px]">
                        <SectionSubheading text={t("home.subheadings.directions")} />
                    </div>
                    <div className="mb-[32px]">
                        <AboutUsDescription paragraphs={paragraphs} />
                    </div>
                </div>
                <DirectionsFeatureBlock />
            </div>
        </section>
    );
}
